module.exports = __webpack_public_path__ + "img/expeditionary-hotspot-1.a076df1c.png";